
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import IconChevron from './icons/IconChevron.vue';

@Component({
  components: {
    IconChevron,
  },
})
export default class NavExpandItem extends Vue {
  @Prop({ default: '' }) icon!: string;

  @Prop({ default: null }) iconComponent!: Record<string, unknown> | null;

  @Prop({ default: false }) mini!: boolean;

  @Prop({ default: false, type: Boolean }) open!: boolean;

  private isExpanded = false;
}
